/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type RevenueRecognitionPage_project = {
    readonly id: string;
    readonly rateCard: {
        readonly id: string;
        readonly currency: string | null;
    } | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly " $fragmentRefs": FragmentRefs<"RevenueRecognition_project" | "TimeRevenueRecognition_project" | "ExpenseRevenueRecognition_project">;
    readonly " $refType": "RevenueRecognitionPage_project";
};
export type RevenueRecognitionPage_project$data = RevenueRecognitionPage_project;
export type RevenueRecognitionPage_project$key = {
    readonly " $data"?: RevenueRecognitionPage_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"RevenueRecognitionPage_project">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RevenueRecognitionPage_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "rateCard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RevenueRecognition_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeRevenueRecognition_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExpenseRevenueRecognition_project"
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = 'b4afd171c478762011a66a87081f9cf9';
export default node;
